import React from "react";
import { object } from "prop-types";

import LeftImageRightNews from "../../../../../molecules/LeftImageRightNews";
import WidgetPlaceholder from "../../../WidgetPlaceholder";
import NewsWithNoImage from "../../../../../molecules/NewsWithNoImage";

import { getStoriesFromCollection, trim } from "../../../../../utils/utils";

import "./left-column.m.css";

const LeftColumn = ({ collection }) => {
  let { "associated-metadata": { widget_80_url: widgetUrl } = {} } = collection;
  widgetUrl = trim(widgetUrl);

  const items = getStoriesFromCollection(collection, 20);
  const stories = [...items.slice(1, 4), ...items.slice(15)];

  return (
    <div>
      <div styleName="container">
        {stories.map((story, index) => {
          if (index === 0) {
            return (
              <LeftImageRightNews styleName="left-item" showExcerpt={true} story={story} key={index} widths={[180]} />
            );
          } else if (index === 1) {
            return (
              <LeftImageRightNews
                styleName="left-item"
                showExcerpt={!widgetUrl}
                story={story}
                key={index}
                widths={[180]}
              />
            );
          } else if (index === 2) {
            return <LeftImageRightNews styleName="left-item" story={story} key={index} widths={[100]} />;
          } else {
            return (
              <NewsWithNoImage
                key={index}
                styleName="left-item"
                showExcerpt={false}
                story={story}
                showPublishedAt={false}
              />
            );
          }
        })}
        <WidgetPlaceholder url={widgetUrl} styleName="widget" height={80} />
      </div>
    </div>
  );
};

LeftColumn.propTypes = {
  collection: object,
};

export default LeftColumn;
